import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import withStyles from '@mui/styles/withStyles';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import Table from '@mui/material/Table';
import TableContainer from '@mui/material/TableContainer';
import Paper from '@mui/material/Paper';
import { TableHead, TableRow, TableCell, TableBody } from '@mui/material';

const styles = (theme) => ({
  paragraph: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  header: {
    marginTop: theme.spacing(2),
  },
  table: {
    overflowX: 'initial',
  },
});

const MarkdownParagraph = withStyles(styles)(({ classes, ...props }) => {
  return (
    <Typography className={classes.paragraph} variant="body1">
      {props.children}
    </Typography>
  );
});

const variantMapping = { h1: 'h1', h2: 'h2', h3: 'h3', h4: 'h4', h5: 'h5', h6: 'h6', subtitle1: 'h5', subtitle2: 'h5', body1: 'p', body2: 'p' };

const MarkdownHeading = withStyles(styles)(({ classes, ...props }) => {
  let variant;
  switch (props.level) {
    case 1:
      variant = 'h3';
      break;
    case 2:
      variant = 'h4';
      break;
    case 3:
      variant = 'h5';
      break;
    default:
      variant = 'h6';
      break;
  }
  const id = typeof props.children[0] === 'string' ? props.children[0].toLowerCase().replace(/[ ]/g, '-') : '';
  return (
    <Typography id={id} className={classes.header} gutterBottom variant={variant} variantMapping={variantMapping}>
      {props.children}
    </Typography>
  );
});

const MarkdownListItem = withStyles(styles)(({ classes, ...props }) => {
  return (
    <li>
      <Typography component="span">{props.children}</Typography>
    </li>
  );
});

const MarkdownTable = withStyles(styles)(({ classes, ...props }) => {
  return (
    <TableContainer className={classes.table} component={Paper}>
      <Table size="small" aria-label="a dense table" stickyHeader>
        {props.children}
      </Table>
    </TableContainer>
  );
});

const renderers = {
  h1: MarkdownHeading,
  h2: MarkdownHeading,
  h3: MarkdownHeading,
  h4: MarkdownHeading,
  h5: MarkdownHeading,
  h6: MarkdownHeading,
  p: MarkdownParagraph,
  link: Link,
  li: MarkdownListItem,
  table: MarkdownTable,
  thead: TableHead,
  tbody: TableBody,
  tr: TableRow,
  td: TableCell,
  th: TableCell,
};

export default function Markdown(props) {
  return <ReactMarkdown remarkPlugins={[remarkGfm]} escapeHtml={false} components={renderers} {...props} />;
}
